// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const passwordRegex = /^(?:(?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*[^A-Za-z\d])|(?=.*\d)(?=.*[^A-Za-z\d])).{8,20}$/;
export const ONLY_DIGITS_REGEX = /[^0-9]{1,100}/g;
export const ONLY_KOREAN_ENGLISH_DIGITS_REGEX = /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣0-9]{1,255}/g;
export const ONLY_KOREAN_ENGLISH_REGEX = /[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣\s]{1,255}/g;
export const ONLY_KOREAN_REGEX = /[^ㄱ-ㅎㅏ-ㅣ가-힣\s]{1,255}/g;
export const TRAILING_HYPHEN_REGEX = /(-{1,2})$/g;

export const RESPONSE_CODE = {
    SUCCESS: '0',
    FAIL: '1'
};

export const responseResult = (code) => {
    return String(code)[0] === RESPONSE_CODE.SUCCESS ? RESPONSE_CODE.SUCCESS : RESPONSE_CODE.FAIL;
};

export const Roles = {
    COM017_10: '디렉터',
    COM017_20: '매니저',
    COM017_30: 'IT 관리자',
    COM017_40: '부서 관리자',
    COM017_50: '임상 관리자',
    COM017_60: '슈퍼 관리자'
};

export const Genders = {
    COM005_10: '남성',
    COM005_20: '여성'
};

export const Educations = {
    COM004_10: '기타',
    COM004_20: '초등학교',
    COM004_30: '중학교',
    COM004_40: '고등학교',
    COM004_50: '전문학사',
    COM004_60: '일반학사',
    COM004_70: '석사',
    COM004_80: '박사'
};

export const ExamResultCodeList = {
    COM019_1: '정상',
    COM019_2: '의심'
};

export const ExamStatusList = {
    COM018_10: '검사 대기',
    COM018_20: '검사 중',
    COM018_30: '검사 완료',
    COM018_40: '검사 만료',
    COM018_50: '검사 취소'
};

export const DeviceStatus = {
    COM020_1: '등록 대기',
    COM020_2: '정상 등록',
    COM020_3: '만료',
    COM020_9: '기타'
};

export const ClinicalStatus = {
    ANN010_1: '입력대기',
    ANN010_2: '입력완료'
};

export const UserStatus = {
    COM002_10: '정상',
    COM002_20: '탈퇴',
    COM002_30: '일시정지',
    COM002_40: '비활성화'
};

export const SubmitResultCode = {
    SUCCESS: '1',
    FAIL: '2',
    SILENCE_SUCCESS: '3'
};
